import angular from 'angular'

angular.module('nominas.nomina')
  .config(function ($stateProvider) {
    $stateProvider.state('nominas.detalladoNomina.layoutH2H', {
      url: '/documentos/layoutsh2h',
      template: '<nomina-documentos-layoutsh2h id-proyecto=idProyecto id-nomina=idNomina></nomina-documentos-layoutsh2h>',
      controller: function ($scope, $stateParams) {
        $scope.idProyecto = $stateParams.idEmpresa
        $scope.idNomina = $stateParams.idNomina
      },
      data: {title: 'Layouts H2H'},
    })
  })



// WEBPACK FOOTER //
// ./src/nominas/nomina/routes/nomina/layouth2h.js